var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('the-header'),_c('loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}]}),_c('div',{staticClass:"container max-w-full"},[_c('router-view')],1),_c('the-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }